module.exports = __webpack_public_path__ + "static/IA-b325ebd44a5778d1041f20c820a5c8b0.jpg";